import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button/index';
import Dialog from '@material-ui/core/Dialog/index';
import DialogActions from '@material-ui/core/DialogActions/index';
import DialogContent from '@material-ui/core/DialogContent/index';
import DialogTitle from '@material-ui/core/DialogTitle/index';
import Zoom from '@material-ui/core/Zoom';
import Fab from "@material-ui/core/Fab";
import IconButton from "@material-ui/core/IconButton";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import DraggableModal from "../../../../Include/DraggableModal/DraggableModal";
import IntegrationNotistack, {ShowSnackBarsNotistack} from "../../../../../settings/IntegrationNotistack/IntegrationNotistack";
import {EnteroSolo, FieldsJs, hideSpinner, showSpinner} from "../../../../../settings/General/General";
import {AttachFile, AttachMoney, Business, DeleteOutlined, Description, EditOutlined, HdrStrong, HomeWork, House, SearchOutlined} from "@material-ui/icons";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import DocSvg from "../../../../../assets/img/icons/doc.svg";
import {DropzoneArea} from "material-ui-dropzone";
import {DropboxApi} from "../../../../../settings/Dropbox/DropboxApi";
import EmpresaAcrescoSucursalService from "../../../../../services/_Cat/EmpresaAcrescoSucursalService/EmpresaAcrescoSucursalService";
import {KeyboardDateTimePicker} from "@material-ui/pickers";
import moment from "moment";
import {BotonAccionAbrirModal, TituloHeaderModal} from "../../../../Include/MiniComponents/GlobalComponent";
import Divider from "@material-ui/core/Divider";
import ModalCentroTrabajoRepositorioJuridico from "../../CentroTrabajoRepositorioJuridico/Includes/ModalCentroTrabajoRepositorioJuridico";
import Add from "@material-ui/icons/Add";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import ModalEmpresaSucursal from "../../EmpresaSucursal/Includes/ModalEmpresaSucursal";
import {CatService} from "../../../../../services/_Cat/CatService/CatService";


class ModalSucursalesSAT extends Component {
	
	state = {};
	
	constructor(props) {
		
		super(props);
		
		this.state = {
			open: false,
			scroll: 'paper',
			id_empresa_sucursal: (props.item || '').id_empresa_sucursal,
			id_empresa: (props.item || '').id_empresa,
			tipo: props.tipo,
			observaciones: '',
			id_cat_empresa_sucursal: '',
			direccion: '',
			fecha_emision: null,
			fecha_apertura: null,
			comprobante_pago: 1,
			files: [],
			archivos: [],
			listar_cat_empresa_sucursal: [],
		};
	}
	
	showSnackBars = (type, message) => {
		ShowSnackBarsNotistack(this.props, type, message, null);
	};
	
	handleChange = (e, variable, campo, date, input) => {
		FieldsJs.HandleChange(e, variable, campo, date, input, (r) => this.setState({
			[r.name]: r.value
		}));
	};
	
	changeValue = (arr_name__key, var_name, var_value) => {
		FieldsJs.ChangeValue(arr_name__key, var_name, var_value, (r) => this.setState({
			[r.name]: r.value
		}), this.state);
	};
	
	openModal = () => {
		this.setState({open: true, scroll: 'paper'});
	};
	
	modalClose = () => {
		this.setState({open: false});
	};
	
	
	guardarDocTimbradoDbx = () => {
		
		let files = this.state.files;
		
		return new Promise((resolve, reject) => {
			let band = files.length;
			let band2 = 0;
			let archives = this.state.archivos;
			let file;
			
			if (band > 0) {
				for (let i = 0; i < files.length; i++) {
					file = files[i];
					
					let ruta = '/Empresas/Sucursales SAT/Comprobante/' + this.state.id_empresa +  '_' + file.name;
					
					DropboxApi.Upload(ruta, file).then(function (response) {
						archives.push({archivo: response.path_display});
						
						band2++;
					
						if (band === band2) {
							resolve(archives);
						}
					}).catch(function (error) {
						reject(error);
					});
					
				}
			} else {
				resolve([]);
			}
			
		});
	};
	
	save = () => {
		
		try {
			
			if (!FieldsJs.Field(this.state.fecha_apertura)) {
				throw Object({
					status: false, mensaje: 'Campo fecha apertura es requerido.'
				})
			}
			
			if (!FieldsJs.Field(this.state.fecha_emision)) {
				throw Object({
					status: false, mensaje: 'Campo fecha emisión es requerido.'
				})
			}
			
			if (!FieldsJs.Field(this.state.direccion)) {
				throw Object({
					status: false, mensaje: 'Campo direccion es requerido.'
				})
			}
			
			/*if (!FieldsJs.Field(this.state.files) && this.state.files.length === 0) {
				throw Object({
					status: false, mensaje: 'No se ha seleccionado el archivo.'
				})
			}*/
			
			let guardar = new Promise((resolve, reject) => {
				showSpinner('spinner');
				this.guardarDocTimbradoDbx(this.state.files).then(response => {
					this.setState({
						archivos: response,
					});
					resolve(response);
				}).catch(error => {
					reject(error);
				})
			});
			
			guardar.then(response => {
				if (this.state.id_empresa_sucursal > 0) {
					EmpresaAcrescoSucursalService.Modificar(this.state).then((response) => {
						this.props.RefreshList();
						this.modalClose();
						hideSpinner('spinner', 500);
						this.showSnackBars('success', response.mensaje);
					}).catch((error) => {
						this.showSnackBars('error', error.mensaje);
					});
				} else {
					EmpresaAcrescoSucursalService.Agregar(this.state).then((response) => {
						this.props.RefreshList();
						this.modalClose();
						this.showSnackBars('success', response.mensaje);
					}).catch((error) => {
						hideSpinner('spinner', 500);
						this.showSnackBars('error', error.mensaje);
					});
				}
			});
			
		} catch (error) {
			this.showSnackBars('error', error.mensaje);
		}
	};
	
	add = () => {
		
		const {item} = this.props;
		
		this.setState({
			id_empresa_sucursal: item.id_empresa_sucursal || '',
			id_empresa: item.id_empresa || '',
			id_cat_empresa_sucursal: '',
			direccion: '',
			observaciones: '',
			fecha_emision: null,
			fecha_apertura: null,
			comprobante_pago: 1,
			archivos: [],
			activo: true,
		});
		
		this.ListEmpresaSucursal();
		
		this.openModal();
		
	};
	
	edit = () => {
		
		const {item} = this.props;
		
		this.ListEmpresaSucursal().then((response) => {
			this.setState({
				id_cat_empresa_sucursal: item.id_cat_empresa_sucursal || '',
			});
		});
		
		
		this.setState({
			id_empresa_sucursal: item.id_empresa_sucursal || '',
			direccion: item.direccion || '',
			id_empresa: item.id_empresa || '',
			fecha_emision: item.fecha_emision ? moment(item.fecha_emision) : null,
			fecha_apertura: item.fecha_apertura ? moment(item.fecha_apertura) : null,
			observaciones: item.observaciones || null,
			comprobante_pago: 1,
			archivos: item.archivos || [],
			activo: (item.activo === 1),
		});
		
		
		this.openModal('paper');
		
	};
	
	view = () => {
		
		const {item} = this.props;
		
		this.ListEmpresaSucursal().then((response) => {
			this.setState({
				id_cat_empresa_sucursal: item.id_cat_empresa_sucursal || '',
			});
		});
		
		this.setState({
			id_empresa_sucursal: item.id_empresa_sucursal || '',
			id_empresa: item.id_empresa || '',
			direccion: item.direccion || '',
			observaciones: item.observaciones || null,
			fecha_emision: item.fecha_emision ? moment(item.fecha_emision) : null,
			fecha_apertura: item.fecha_apertura ? moment(item.fecha_apertura) : null,
			comprobante_pago: 1,
			archivos: item.archivos || [],
			activo: (item.activo === 1),
		});
		
		this.openModal('paper');
		
	};
	
	handleChangeDropzoneArea = (files) => {
		this.setState({
			files: files
		});
	};
	
	eliminar_documento = (key) => {
		var arr_temp = FieldsJs.Copy(this.state.archivos);
		arr_temp.splice(key, 1);
		this.setState({
			archivos: arr_temp
		});
	};
	
	ListEmpresaSucursal = () => {
		return new Promise((resolve, reject) => {
			CatService.ListEmpresaSucursal().then((response) => {
				this.setState({
					listar_cat_empresa_sucursal: response.data,
				});
				resolve(response);
			}).catch((error) => {
				this.setState({listar_cat_empresa_sucursal: []});
				this.showSnackBars('error', error.mensaje);
			});
		});
	};
	
	RefreshListEmpresaSucursal = (id_cat_empresa_sucursal) => {
		this.ListEmpresaSucursal().then((response) => {
			let centros = FieldsJs.Copy(this.state.listar_cat_empresa_sucursal);
			let direccion = '';
			for (let i = 0; i < centros.length; i++) {
				if (Number(id_cat_empresa_sucursal) === Number(centros[i].id_cat_empresa_sucursal)) {
					direccion = centros[i].direccion;
				}
			}
			this.setState({
				id_cat_empresa_sucursal: id_cat_empresa_sucursal,
				direccion: direccion,
			});
		});
	};
	
	BOTON_ACCION = () => {
		var BTN_ACTION = '';
		
		if (this.state.id_empresa_sucursal > 0) {
			if (this.state.tipo === 'edit') {
				BTN_ACTION = (
					<Tooltip TransitionComponent={Zoom} placement={"top"} title="Estatus">
						<IconButton aria-label="Estatus" onClick={() => this.edit()}>
							<HdrStrong/>
						</IconButton>
					</Tooltip>
				);
			} else if (this.state.tipo === 'view') {
				BTN_ACTION = (
					<Tooltip TransitionComponent={Zoom} placement={"top"} title="Detalles">
						<IconButton aria-label="Detalles" onClick={() => this.view()}>
							<SearchOutlined/>
						</IconButton>
					</Tooltip>
				);
			}
		} else {
			BTN_ACTION = (
				<Tooltip TransitionComponent={Zoom} placement={"top"} title="Sucursales SAT">
					<IconButton aria-label="Sucursales SAT" onClick={() => this.add()}><Business/></IconButton>
				</Tooltip>
			);
		}
		return BTN_ACTION;
	};
	
	render() {
		
		let funcion;
		
		switch (this.state.tipo) {
			case 'edit':
				funcion = this.edit;
				break;
			case 'add':
				funcion = this.add;
				break;
			case 'view':
				funcion = this.view;
				break;
			default:
				funcion = () => {
				};
		}
		
		return (
			<div>
				
				{this.props.componente ? (
					<Fragment>
						<span
							style={{cursor: 'pointer'}}
							children={this.props.componente}
							onClick={() => funcion()}
						/>
					</Fragment>
				) : (
					<BotonAccionAbrirModal
						id={this.state.id_empresa_sucursal}
						tipo={this.state.tipo}
						onClick={() => funcion()}
					/>
				)}
				
				<Dialog disableBackdropClick disableEscapeKeyDown maxWidth={'sm'} open={this.state.open}
				        fullWidth={true} scroll={this.state.scroll} onClose={this.modalClose}
				        aria-labelledby="scroll-dialog-title"
				        PaperComponent={DraggableModal}
				>
					
					<DialogTitle>
						<TituloHeaderModal
							tipo={this.state.tipo}
							titulo={'Sucursal SAT'}
						/>
					</DialogTitle>
					
					<DialogContent className={'padding-20'}>
						
						<Grid container spacing={2}>
							
							<Grid item className={'text-left'} xs={12} sm={12} md={12} lg={12} xl={12}>
								<div className={'row-flex'}>
									<div className={'w-50-px v-end'}>
										<ModalEmpresaSucursal
											tipo={'add'}
											item={{}}
											componente={
												<Tooltip TransitionComponent={Zoom} placement={"top"} title="Agregar Sucursal">
													<Fab size="small" color="primary" aria-label="Agregar Sucursal">
														<Add/>
													</Fab>
												</Tooltip>
											}
											RefreshList={this.RefreshListEmpresaSucursal}
											showSnackBars={this.props.showSnackBars}
										/>
									</div>
									<div className={'w-100-50-px padding-10-R'}>
										<FormControl fullWidth required>
											<InputLabel>Sucursal:</InputLabel>
											<Select
												native
												value={this.state.id_cat_empresa_sucursal}
												onChange={(e) => {
													this.handleChange(e);
													this.RefreshListEmpresaSucursal(e.target.value);
												}}
												name="id_cat_empresa_sucursal"
												input={<Input/>}
												disabled={this.state.tipo === 'view'}
											>
												<option value=""/>
												{this.state.listar_cat_empresa_sucursal.map(option => (
													<option key={option.id_cat_empresa_sucursal}
													        value={option.id_cat_empresa_sucursal}>
														{option.nombre}
													</option>
												))}
											</Select>
										</FormControl>
									</div>
								</div>
							</Grid>
							
							<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
								<KeyboardDateTimePicker
									format="yyyy/MM/dd hh:mm a"
									fullWidth
									disabled={this.state.tipo === 'view'}
									required
									clearable
									inputProps={{readOnly: true}}
									KeyboardButtonProps={{
										'aria-label': 'Fecha de apertura',
									}}
									label="Fecha de apertura"
									value={this.state.fecha_apertura}
									onChange={(date) => {
										this.handleChange(null, null, null, date, 'fecha_apertura');
									}}
									// minDate={moment(new Date())}
									clearLabel={'Limpiar'}
									okLabel={'Aceptar'}
									cancelLabel={'Cancelar'}
									onError={console.log}
								/>
							</Grid>
							
							<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
								<KeyboardDateTimePicker
									format="yyyy/MM/dd hh:mm a"
									fullWidth
									disabled={this.state.tipo === 'view'}
									required
									clearable
									inputProps={{readOnly: true}}
									KeyboardButtonProps={{
										'aria-label': 'Fecha de emisión de la CIF',
									}}
									label="Fecha de emisión de la CIF"
									value={this.state.fecha_emision}
									onChange={(date) => {
										this.handleChange(null, null, null, date, 'fecha_emision');
									}}
									// minDate={moment(new Date())}
									clearLabel={'Limpiar'}
									okLabel={'Aceptar'}
									cancelLabel={'Cancelar'}
									onError={console.log}
								/>
							</Grid>
							
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								
								<TextField
									name="direccion"
									label="Dirección"
									required
									type="text"
									fullWidth
									value={this.state.direccion}
									onChange={this.handleChange}
									disabled={this.state.tipo === 'view'}
								/>
							
							</Grid>
							
							
							{/*{this.state.archivos.length > 0 ? (
								<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
									<Typography className={'padding-10-T padding-10-B px-14 text-left'} style={{fontWeight: 'bold'}}>
										Documento(s) Anexo:
									</Typography>
									<div className={'vertical-inline'}>
										{this.state.archivos.map((item, key) => (
											<div>
												<div className={'vertical-inline b-r-20 margin-5 margin-0-L'} key={key}>
													<img className={'v-center cursor-pointer'} src={DocSvg} alt="add" width={40} height={40} style={{opacity: 0.7, marginRight: '5px'}} onClick={() => this.descargarZip(item.archivo)}/>
													
													
													{this.props.tipo === 'edit' ? (<div className={'vertical-inline v-end b-r-20 margin-5 ' + (this.props.tipo === 'view' ? 'bg-gray' : 'bg-danger')} key={key}>
														<div className={'padding-3 v-end text-white cursor-pointer'}>
															{this.props.tipo === 'view' ? null : (
																<DeleteOutlined className={'px-16 text-white'} onClick={() => this.eliminar_documento(key)}/>
															)
															}
														</div>
													</div>) : null}
												</div>
											
											
											</div>
										))}
									</div>
								</Grid>
							) : null}*/}
							
							{this.props.tipo !== 'view' ? (
								<Grid item xs={12} sm={12} md={12} lg={12} xl={12} className={'dropzone-cronograma'}>
									<Typography className={'padding-10-T padding-10-B px-14 text-left'} style={{fontWeight: 'bold'}}>
										Comprobante de domicilio:
									</Typography>
									<div className={'w-100'}>
										<DropzoneArea
											onChange={this.handleChangeDropzoneArea.bind(this)}
											open={this.state.open}
											filesLimit={1}
											dropzoneText={'Arrastre y suelte un archivo aquí o haga clic'}
											acceptedFiles={['application/pdf']}
											showPreviews={false}
											maxFileSize={5000000}
											showAlerts={false}
											showFileNames={true}
											showFileNamesInPreview={true}
										/>
									</div>
								</Grid>
							) : null}
						
						</Grid>
					
					</DialogContent>
					
					<Divider/>
					
					<DialogActions>
						
						<Button onClick={() => this.modalClose()} color="primary">
							{this.state.tipo === 'view' ? 'Cerrar' : 'Cancelar'}
						</Button>
						
						{this.state.tipo !== 'view' ? (
							<Button onClick={() => this.save()} color="primary">
								{this.state.id_empresa_sucursal > 0 ? 'Actualizar' : 'Agregar'}
							</Button>
						) : ''}
					
					</DialogActions>
				
				</Dialog>
			
			</div>
		);
	}
}

ModalSucursalesSAT.propTypes = {
	componente: PropTypes.element,
	tipo: PropTypes.string.isRequired,
	item: PropTypes.object.isRequired,
	RefreshList: PropTypes.func.isRequired,
	showSnackBars: PropTypes.func.isRequired
};

export default IntegrationNotistack(ModalSucursalesSAT);
